<template>
  <div class="uploadFile">
    <div class="warn-message">
      <slot name="message"></slot>
    </div>
    <el-upload
      ref="uploadFile"
      :class="{ del: !ifUploadBtn }"
      :action="uploadUrl"
      :data="dataFile"
      :headers="headers"
      :before-upload="beforeUpload"
      :auto-upload="autoUpload"
      :limit="limit"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :on-change="onChange"
      :on-success="handleFileSuccess"
      :on-error="errFunction"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :disabled="isUploadDisabled"
      :accept="accept"
      :show-file-list="true"
    >
      <eui-btn :disabled="isUploadDisabled" v-show="ifUploadBtn">
        <eui-icon icon="eicon-upload"></eui-icon>
        上传文件
      </eui-btn>
    </el-upload>
    <span
      @click.stop=""
      :style="{ left: ifUploadBtn ? '104px' : 0 }"
      class="tips-Message"
      v-if="tipsMessage"
    >
      {{ tipsMessage }}
    </span>

    <template>
      <div class="error" v-show="uploadTips">请选择附件</div>
    </template>

    <div @click.stop="" class="view" v-viewer="options" v-show="false">
      <img :src="viewUrl" />
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
import Vue from 'vue';
import { dealAttachmentName } from '@/modules//projectA/utils/utils';
Vue.use(VueViewer);
export default {
  name: 'uploadFile',
  props: {
    // 提示信息
    tipsMessage: {
      type: String,
      default: ''
    },
    //上传文件的大小
    fileSize: {
      type: Number,
      default: 8
    },
    //是否已完结请求 就是默认请求完成后 可能还需要再次请求个上传接口 需要调两个接口 第二个需要路径啥的
    isEndUplad: {
      type: Boolean,
      default: true
    },
    // 上传文件的接口地址
    uploadUrl: {
      type: String,
      required: true
    },
    // 上传文件的附带参数，由后端来定
    dataFile: {
      type: Object,
      default: function() {
        return {};
      }
    },
    // 是否显示上传按钮
    ifUploadBtn: {
      type: Boolean,
      default: true
    },
    // 上传文件个数限制
    limit: {
      type: Number,
      default: 1
    },
    // 用于回显的文件地址
    url: {
      type: Array,
      default: function() {
        return [];
      }
    },
    /*是否自动上传*/
    autoUpload: {
      type: Boolean,
      default: true
    },
    /*手动上传时外部弹窗按钮控制*/
    btnStatus: {
      type: Boolean,
      default: false
    },
    /*父组件弹窗是否显示*/
    dialogShow: {
      type: Boolean,
      default: true
    },
    // 必填项时需传verify：true ,uploadTips：false,并在父组件保存按钮加个判断，非必填这些不写
    // 是否必填验证
    verify: {
      type: Boolean,
      default: false
    },
    // 提示信息
    uploadTips: {
      type: Boolean,
      default: false
    },
    // 只能上传pdf
    isPDF: {
      type: Boolean,
      default: false
    },
    // 只能上xlsx
    isOnlyXlsx: {
      type: Boolean,
      default: false
    },
    isOnlyWord: {
      type: Boolean,
      default: false
    },
    // 是否禁止
    isUploadDisabled: {
      type: Boolean,
      default: false
    },
    // 文件类型
    accept: {
      type: String,
      // .jpg,.jpeg,.png,.pdf
      default: ''
      // default: ".jpg,.jpeg,.png,.pdf",
    },
    uploadImage: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: function() {
        return { navbar: false, zIndex: 99999999999999999 };
      }
    }
    /* uploadFile: {
      type: Boolean,
      default: true
    } */
  },
  data() {
    return {
      // 上传的文件列表,文件编辑回显的时候用到
      fileList: [],
      // 接口返回的文件信息
      fileInfo: [],
      pdf: {
        showPDF: false,
        title: '预览PDF',
        pdfUrl: ''
      },
      exportList: [], //与上传文件，当上传选项为必填时用来判断是否显示“请选择附件的提示”
      delKey: '',
      headers: null,
      viewUrl: '',
      vector: require('@/assets/img/enquiry/Vector.png')
    };
  },
  components: {},
  mounted() {
    // 文件回显
    if (this.url) {
      this.fileList = [];
      this.url.forEach(ele => {
        this.fileList.push({
          url: ele.url,
          name: this.dealAttachmentName(ele.fileName)
        });

        this.fileInfo.push({
          fileUrl: ele.url,
          fileName: ele.fileName
        });
      });
    }
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    }
  },
  watch: {
    url(val) {
      if (val) {
        this.fileList = [];
        val.forEach(ele => {
          this.fileList.push({
            url: ele.url,
            name: this.dealAttachmentName(ele.fileName)
          });

          this.fileInfo.push({
            fileUrl: ele.url,
            fileName: ele.fileName
          });
        });
      }
    },
    mall_userInfo: {
      immediate: true,
      handler: function(newval) {
        console.log(
          this.$cookies.get('epecToken'),
          'this.$cookies.get("epecToken")this.$cookies.get("epecToken")this.$cookies.get("epecToken")'
        );
        this.headers = {
          'epec-sso-token': this.$cookies.get('epecToken'),
          'epec-from': 'WEB_SITE',
          'epec-locale': 'ZH',
          'epec-company-id': newval.companyId
        };
        console.log(this.headers);
      }
    }
  },
  methods: {
    changeRadio(val, index) {
      this.fileInfo[index].isSupplierVisible = val;
      this.$emit('getFileInfo', this.fileInfo);
      console.log(this.fileInfo);
    },
    dealAttachmentName,
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },
    // 文件fliesize及格式校验
    isFileSize(file) {
      if (file.size / 1024 / 1024 > this.fileSize) {
        return false;
      }
      return true;
    },
    // 验证
    handleCheck(file, { isPdf }) {
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message({
          message: `请上传小于${this.fileSize}M的文件!`,
          type: 'error'
        });
        return false;
      }
      if (file.name.includes(',')) {
        this.$message({
          message: '文件名格式错误!',
          type: 'error'
        });
        return false;
      }
      if (this.isPDF && !this.autoUpload) {
        if (!isPdf) {
          this.$message({
            message: '上传文件只能是pdf格式!',
            type: 'error'
          });
          return false;
        }
      }
      return true;
    },
    /*如果是点击取消按钮则清空已上传的文件列表*/
    cancelDialog() {
      this.$refs.uploadFile.clearFiles();
      this.exportList = [];
    },
    //点击按钮上传文件
    submitUpload() {
      /**/
      if (this.verify && this.exportList <= 0) {
        this.$emit('update:uploadTips', true);
        this.$emit('update:btnStatus', false);
      }
      this.$refs.uploadFile.submit();
    },
    // 显示图片预览弹层
    show() {
      const viewer = this.$el.querySelector('.view').$viewer;
      viewer.show();
    },
    // 预览pdf
    handleFilePreview(file, fileList) {
      console.log(file, fileList, '预览pdf');
      let testmsg = (file.name && this.commonHandleCheck(file.name)) || null;
      if (file.name && testmsg === 'pdf') {
        this.pdf.pdfUrl = file.url;
        this.pdf.showPDF = true;
      }

      if (
        file.name &&
        (testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'jpg')
      ) {
        this.viewUrl = file.url;
        this.show();
      }
      // 上传的
      if (file.response) {
        let testmsg = this.commonHandleCheck(file.name);
        if (testmsg === 'pdf') {
          this.pdf.pdfUrl = file.response.data.fileUrl;
          this.pdf.showPDF = true;
        }
        if (testmsg === 'jpeg' || testmsg === 'png' || testmsg === 'jpg') {
          this.viewUrl = file.response.data.fileUrl;
          this.show();
        }
      }
    },
    // 上传之前文件验证
    beforeUpload(file) {
      // 是否自动上传
      if (this.autoUpload) {
        if (!this.isFileSize(file)) {
          this.$message({
            message: `上传文件大小不能超过 ${this.fileSize}MB!`,
            type: 'error'
          });
          this.$emit('getBtnStatus', true);
          return false;
        }

        return this.isFileSize(file);
      }
    },
    // 改变文件的钩子
    onChange(file, fileList) {
      console.log('onChange');
      let testmsg = this.commonHandleCheck(file.name);
      const isPdf = testmsg === 'pdf';
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';
      const isWord = testmsg === 'doc' || 'docx';
      // 图片文件
      // const isJpg = testmsg === "jpg";
      // const isJpeg = testmsg === "jpeg";
      // const isPng = testmsg === "png";
      const isFileSize = file.size / 1024 / 1024 < this.fileSize;
      // 手动上传校验
      if (!this.autoUpload) {
        // 避免有些是手动上传文件，直接在on-change上进行文件校验
        /* if (!this.handleCheck(file, { isPdf })) {
          if (this.autoUpload) {
            fileList.length && this.$refs.uploadFile.clearFiles();
            return false;
          } else {
            fileList.forEach((item, index) => fileList.splice(index, 1));
            return false;
          }
        } */
        /* // 只能上传xlsx
        if (this.isOnlyXlsx === true) {
          if (!isXlsx) {
            for (let index = 0; index < fileList.length; index++) {
              fileList.splice(index, 1);
            }
            this.$message({
              message: "上传文件只能是xlsx!",
              type: "error",
            });
            return false;
          } else {
            this.exportList = fileList;
            this.$emit("update:uploadTips", false);
          }
          return (isXlsx || isXls) && isFileSize;
        } */
        console.log(this.isOnlyWord, 'this.isOnlyWord');
        if (this.isOnlyWord === true) {
          if (!isWord) {
            for (let index = 0; index < fileList.length; index++) {
              fileList.splice(index, 1);
            }
            this.$message({
              message: '上传文件只能是word!',
              type: 'error'
            });
            return false;
          } else {
            this.exportList = fileList;
            this.$emit('update:uploadTips', false);
          }
          return isWord && isFileSize;
        }
      }
      if (this.isOnlyWord === true) {
        if (!isWord) {
          for (let index = 0; index < fileList.length; index++) {
            fileList.splice(index, 1);
          }
          this.$message({
            message: '上传文件只能是word!',
            type: 'error'
          });
          return false;
        } else {
          this.exportList = fileList;
          this.$emit('update:uploadTips', false);
        }
        return isWord && isFileSize;
      }
    },
    // 上传成功的钩子
    handleFileSuccess(response, file, fileList) {
      console.log(response, '上传成功的钩子------');
      if (response.code === '200') {
        if (response.data) {
          const { fileName, url } = response.data;
          this.fileInfo.push({
            fileName,
            fileUrl: url
          });
          this.fileList.push({
            name: this.dealAttachmentName(fileName),
            url
          });
          console.log(this.fileList, 'this.fileList');
        }
        this.$emit('getFileInfo', this.fileInfo);
        // 成功干掉提示
        this.$emit('update:uploadTips', false);
      } else {
        this.$message.error(response.message);
        this.$emit('getFileInfo', response);
      }
      /*不管成功还是失败都将弹窗中选择的文件清空*/
      for (let index = 0; index < fileList.length; index++) {
        fileList.splice(index, 1);
      }

      if (!this.autoUpload) {
        /*手动时不管返回值是几都需要将确定按钮的状态还原*/
        this.$emit('update:btnStatus', false);
      }
    },
    // 上传失败的钩子
    errFunction() {
      this.$message.error('上传失败');
      this.$emit('update:btnStatus', false);
      this.$emit('getBtnStatus', true);
    },
    // 移除的钩子
    handleRemove(file) {
      console.log(file, '需要移除的文件名字!!!!');
      /*是否自动上传*/
      if (this.autoUpload) {
        // 由于elemenUI上传文件之间的校验返回false就会触发删除事件
        const url = file?.response?.data?.url || file.url;
        for (let index = 0; index < this.fileInfo.length; index++) {
          if (this.fileInfo[index].fileUrl == url) {
            this.fileInfo.splice(index, 1);
            break;
          }
        }
        for (let index = 0; index < this.fileList.length; index++) {
          if (this.fileList[index].url == url) {
            this.fileList.splice(index, 1);
            break;
          }
        }
      }
      this.$emit('getFileInfo', this.fileInfo);
    },
    // 移除前的钩子
    beforeRemove(file) {
      if (this.autoUpload) {
        console.log(this.isPDF, 'this.isPDF ');
        // 由于elemenUI上传文件之间的校验返回false就会触发删除事件
        if (this.isPDF == true) {
          let testmsg = this.commonHandleCheck(file.name);
          if (testmsg == 'pdf') {
            // 回显的，后台没返回size，，，刚上传的点击删除，或者验证小于8兆也会触发，
            if (!file.size || (file.size && file.size / 1024 / 1024 < 8)) {
              // 删除提示
              return this.$confirm(
                `您正在操作删除 ${file.name} 文件，此文件将直接删除，并无法恢复，是否确认？`,
                '提示'
              );
            }
          }
        } else {
          if (this.uploadImage) {
            let testmsg = this.commonHandleCheck(file.name);
            if (testmsg == 'xlsx' || testmsg == 'xls' || testmsg == 'doc') {
              return;
            }
            if (this.fileFormat(file)) {
              // 删除提示
              return this.$confirm(
                `您正在操作删除 ${file.name} 文件，此文件将直接删除，并无法恢复，是否确认？`,
                '提示'
              );
            }
          } else {
            if (this.fileFormat(file)) {
              // 删除提示
              return this.$confirm(
                `您正在操作删除 ${file.name} 文件，此文件将直接删除，并无法恢复，是否确认？`,
                '提示'
              );
            }
          }
          console.log(this.fileFormat(file), 'sdfsfsdfs');
        }
      }
    },
    // 验证调删除事件时的文件规则
    fileFormat(file) {
      let testmsg = this.commonHandleCheck(file.name);
      const isPdf = testmsg === 'pdf';
      const isDoc = testmsg === 'doc';
      const isXls = testmsg === 'xls';
      const isXlsx = testmsg === 'xlsx';

      const isPng = testmsg === 'png';
      const isJpg = testmsg === 'jpg';
      const isJpeg = testmsg === 'jpeg';
      let isFileSize = false;
      // 回显的，后台没返回size，，，刚上传的点击删除，或者验证小于8兆也会触发，
      if (
        !file.size ||
        (file.size && file.size / 1024 / 1024 < this.fileSize)
      ) {
        isFileSize = true;
      } else {
        isFileSize = false;
      }
      return (
        (isPdf || isDoc || isXls || isXlsx || isPng || isJpg || isJpeg) &&
        isFileSize
      );
    },
    // 文件超出个数限制时的钩子
    handleExceed() {
      this.$message.error(`当前限制选择 ${this.limit} 个文件`);
    }
  }
};
</script>

<style lang="scss" scoped>
.uploadFile {
  position: relative;
  .file-list-wrapper {
    margin-top: 10px;
    .file-list-item {
      display: flex;
      align-items: center;
      font-size: 14px;
      .file-name {
        flex-shrink: 0;
        flex-grow: 0;
        width: 236px;
        color: #0064c8;
        margin: 0 10px 0 12px;
      }
      .el-icon-close {
        font-weight: bold;
        cursor: pointer;
      }
      img {
        display: block;
        width: 12px;
        height: 16px;
      }
    }
    ::v-deep .el-radio__inner {
      width: 18px;
      height: 18px;
      &::after {
        width: 6px;
        height: 6px;
      }
    }
  }
  .tips-Message {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 12px;
    color: #999;
  }
  ::v-deep .el-upload-list__item.is-success.focusing .el-icon-close-tip {
    display: none !important;
  }
  ::v-deep .el-upload-list__item {
    transition: none;
  }
  ::v-deep .el-upload-list {
    width: 50%;
  }
  ::v-deep .el-icon-close-tip {
    display: none;
  }
  .error {
    font-size: 12px;
    color: #f56c6c;
  }
  .del {
    ::v-deep .el-upload-list {
      .el-upload-list__item:hover {
        .el-icon-close {
          display: none;
        }
      }
    }
  }
}
</style>
